module.exports = __webpack_public_path__ + "img/LogoFull.00a46c22.png";